import { Button } from '@/components/ui/Button';
import React from 'react';
import { toggleApply } from '../../app/redux/actions/globalModalAction';
import { addBookmark } from '../../app/redux/features/bookmark/addBookmark';
import { useAppDispatch } from '../../app/redux/hooks';
import { Opportunity } from '../../types/content';
import { OpportunityOrganisationLogo } from '../layout/opportunity/OpportunityUtils';
import { useGlobalModal } from './useGlobalModal';

type Props = {
  opportunity: Opportunity;
};

/**
 * Encompasses apply modal behaviour passed through to global modal.
 */
export const ApplyModal = ({ opportunity }: Props) => {
  const dispatch = useAppDispatch();
  const { close: closeModal } = useGlobalModal();

  const handleOnClick = () => {
    dispatch(addBookmark({ entityUuid: opportunity.uuid, state: { label: 'applied' } }));
    dispatch(toggleApply(false, opportunity));
    closeModal();
  };
  return (
    <>
      <div className="flex flex-col items-center justify-center ">
        <div className="text-xl font-bold pb-4"> Did you apply?</div>
        <OpportunityOrganisationLogo
          opportunity={opportunity}
          className="p-1 h-28 w-28 mx-auto mb-3 md:mx-0"
          imageClassName="w-[104px]"
        />
        <div className="pb-2 font-semibold">
          {opportunity.organisation?.title ?? opportunity.sourceOrganisationName}
        </div>
        <div className="pb-6">{opportunity.title}</div>
        <Button className="w-full mb-2" onClick={handleOnClick}>
          Yes
        </Button>
        <Button
          className="w-full"
          variant="outline"
          onClick={() => {
            dispatch(toggleApply(false, opportunity));
            closeModal();
          }}
        >
          No
        </Button>
      </div>
    </>
  );
};
